import * as React from 'react';

export const ExpandedSmallIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.0001 7.4988C10.2134 7.4988 10.4268 7.5804 10.5893 7.7429L13.9226 11.0763C14.2484 11.4021 14.2484 11.9288 13.9226 12.2547C13.5968 12.5805 13.0701 12.5805 12.7442 12.2547L10.0001 9.5105L7.256 12.2547C6.9301 12.5805 6.4034 12.5805 6.0776 12.2547C5.7517 11.9288 5.7517 11.4021 6.0776 11.0763L9.4109 7.7429C9.5734 7.5804 9.7868 7.4988 10.0001 7.4988Z"
      fill="black"
    />
  </svg>
);
